import React, { useEffect } from "react";
import { defaultAction } from "@actions/defaultAction";
import {
  HIDE_LOADING,
  SELL_ORDER_PROCESS_RUNNING,
  SHOW_TWILIO_POPUP,
  RESET_SELL
} from "@constants/actionTypes";
import { closeModal, reset, setFlow, flowReset } from "./action";
import { fetchOrderDetails } from "./thunk";
import { message } from "../Messages/selector";
import { clearMessage } from "../Messages/action";
import OrderVerificationMain from "./OrderVerificationMain";
import styled from "@emotion/styled";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

const MainContainer = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(31, 32, 33, 0.8);
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 113;

  @media (max-height: 700px) {
    overflow: scroll;
  }
`;

const MainContent = styled.div`
  border-radius: 30px;
  background-color: #ffffff;
  margin: 0 auto;
  margin-top: 190px;
  width: 612px;

  @media (max-height: 1000px) {
    margin-top: 150px;
  }
  @media (max-height: 875px) {
    margin-top: 125px;
  }
  @media (max-height: 815px) {
    margin-top: 90px;
  }
  @media (max-height: 715px) {
    margin-top: 50px;
  }

  @media (max-width: 615px) {
    width: 100%;
  }
`;

const CloseDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  color: #9b9b9b;
  align-self: flex-start;
  padding-top: 11px;
  padding-right: 11px;
  padding-left: 11px;
`;

const CloseSpan = styled.span`
  cursor: pointer;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CloseDivImage = styled.img`
  width: 17px;
`;

const OrderVerificationModal = ({
  orderUUID,
  type,
  closable,
  page,
  activeSellOrder
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const isModalOpen = useSelector(state => state.orderVerification.isModalOpen);
  const theMessage = useSelector(state => message(state));

  const flow = ["select-phone", "enter-code", "done"];

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
    dispatch(setFlow(flow));
    dispatch(flowReset());
    if (!page) {
      dispatch(fetchOrderDetails({ orderId: orderUUID, type: type }));
    }

    return () => {
      dispatch(clearMessage());
      dispatch(reset());
      dispatch({ type: SELL_ORDER_PROCESS_RUNNING, payload: false });
    };
  }, []);

  if (!isModalOpen && !orderUUID) return null;

  return (
    <MainContainer>
      <MainContent className="animated fadeInDown">
        <>
          {(theMessage || closable) && (
            <CloseDiv>
              <CloseSpan
                onClick={() => {
                  dispatch(closeModal());
                  dispatch(defaultAction(HIDE_LOADING));
                  if (activeSellOrder) {
                    dispatch(defaultAction(SHOW_TWILIO_POPUP, false));
                    dispatch(defaultAction(RESET_SELL));
                    history.push("/account/sell/");
                  }
                }}
              >
                <CloseDivImage
                  src="https://cdn.cardcash.com/website/ui/elements/close.svg"
                  aria-hidden="true"
                  alt="close button"
                />
              </CloseSpan>
            </CloseDiv>
          )}

          <OrderVerificationMain
            flow={flow}
            orderUUID={orderUUID}
            type={type}
            closable={closable}
            page={page}
            activeSellOrder={activeSellOrder}
          />
        </>
      </MainContent>
    </MainContainer>
  );
};

export default OrderVerificationModal;
